module.exports = __webpack_public_path__ + "static/media/CAFFENIO_white.a0e1404a.svg";